export const BACKEND_URL_PUBLIC = process.env.REACT_APP_BACKEND_URL;
export const BRB_REASONS = ["Lunch", "Comfort", "Away from desk", "Other"];

export function dur(sec) {
  const s = Math.max(0, Math.round(sec || 0));
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} min`;
  return `${Math.floor(m / 60)}h ${m % 60}m`;
}

export function since(iso) {
  return iso ? dur((Date.now() - new Date(iso).getTime()) / 1000) : "—";
}

export function clock(iso) {
  return iso ? new Date(iso).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" }) : "—";
}
